export default __webpack_public_path__ + "static/media/example.5d81b105.png";